(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor( ) {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    const testCookieValue = getCookie('testCookie');
        if (testCookieValue) {
            document.cookie = 'testCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        } else{

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              this.header.classList.add('scrolled-past-header');
              if (this.preventHide) return;
              requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              this.header.classList.add('scrolled-past-header');
              if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
              }
            } else if (scrollTop <= this.headerBounds.top) {
              this.header.classList.remove('scrolled-past-header');
              requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ==================================================================
     Desktop mega menu hover controller  <mega-menu-hover>
     ------------------------------------------------------------------
     - Desktop + fine pointer only; touch and the mobile drawer are untouched.
     - Drives the native <details open> state, so details-disclosure.js,
       global.js (aria / Escape) and StickyHeader keep working as before.
     - Sizes an invisible "bridge" inside the <summary> that spans the gap
       between the trigger and the panel (header padding), and adds a short
       close grace period for diagonal movement.
     - One timer pair per item; opening an item cancels every other item's
       timers, so a stale timer can never close a freshly opened menu.
     - All listeners hang off one AbortController and are removed in
       disconnectedCallback, so Theme Editor section reloads never stack
       listeners or leave timers running.
     Defined before the header-menu fallback below on purpose: if that
     fallback ever throws, this controller is already registered.
     ================================================================== */
  (function () {
    if (customElements.get('mega-menu-hover')) return;

    const MEGA_MENU_CLOSE_DELAY = 250;  // ms grace period after the pointer leaves trigger + panel
    const MEGA_MENU_SWITCH_DELAY = 80;  // ms intent delay when sliding onto a neighbour while a menu is open
    const MEGA_MENU_MEDIA = '(min-width: 990px) and (hover: hover) and (pointer: fine)';

    class MegaMenuHover extends HTMLElement {
      connectedCallback() {
        this.nav = this.closest('.header__inline-menu');
        if (!this.nav) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.mediaQuery = window.matchMedia(MEGA_MENU_MEDIA);
        this.timers = new Map();
        this.lastPointerType = 'mouse';
        this.scrollFrame = null;

        this.items = Array.from(this.nav.querySelectorAll('header-menu')).filter((item) => this.getParts(item));

        this.items.forEach((item) => {
          const { details, summary } = this.getParts(item);
          this.timers.set(item, { open: null, close: null });
          item.addEventListener('pointerenter', (event) => this.onPointerEnter(item, event), { signal });
          item.addEventListener('pointerleave', (event) => this.onPointerLeave(item, event), { signal });
          summary.addEventListener('click', (event) => this.onSummaryClick(item, event), { signal });
          details.addEventListener('toggle', () => this.onToggle(item), { signal });
        });

        this.nav.addEventListener('pointerdown', (event) => {
          this.lastPointerType = event.pointerType || 'mouse';
        }, { signal, capture: true });

        document.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });
        document.addEventListener('click', (event) => this.onDocumentClick(event), { signal });
        window.addEventListener('resize', () => this.refreshOpenBridges(), { signal, passive: true });
        window.addEventListener('scroll', () => {
          // header height can change on scroll (reduce-logo-size); keep the bridge exact
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.refreshOpenBridges();
          });
        }, { signal, passive: true });

        this.onMediaChange = () => {
          if (!this.mediaQuery.matches) this.closeAll();
        };
        if (typeof this.mediaQuery.addEventListener === 'function') {
          this.mediaQuery.addEventListener('change', this.onMediaChange, { signal });
        } else if (typeof this.mediaQuery.addListener === 'function') {
          this.mediaQuery.addListener(this.onMediaChange); // Safari < 14
          this.usesLegacyMediaListener = true;
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.usesLegacyMediaListener && this.mediaQuery) this.mediaQuery.removeListener(this.onMediaChange);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.timers) {
          this.timers.forEach((timer) => {
            clearTimeout(timer.open);
            clearTimeout(timer.close);
          });
        }
        this.timers = new Map();
        this.items = [];
      }

      getParts(item) {
        const details = item.querySelector(':scope > details.mega-menu');
        if (!details) return null;
        const summary = details.querySelector(':scope > summary');
        if (!summary) return null;
        return {
          details,
          summary,
          content: details.querySelector(':scope > .mega-menu__content'),
        };
      }

      isEnabled(event) {
        if (!this.mediaQuery || !this.mediaQuery.matches) return false;
        return !(event && event.pointerType === 'touch');
      }

      isOpen(item) {
        const parts = this.getParts(item);
        return Boolean(parts && parts.details.hasAttribute('open'));
      }

      getTimer(item) {
        let timer = this.timers.get(item);
        if (!timer) {
          timer = { open: null, close: null };
          this.timers.set(item, timer);
        }
        return timer;
      }

      clearTimers(item) {
        const timer = this.getTimer(item);
        clearTimeout(timer.open);
        clearTimeout(timer.close);
        timer.open = null;
        timer.close = null;
      }

      onPointerEnter(item, event) {
        if (!this.isEnabled(event)) return;
        const timer = this.getTimer(item);

        // Re-entering trigger, bridge or panel cancels a pending close immediately
        clearTimeout(timer.close);
        timer.close = null;

        if (this.isOpen(item)) {
          this.updateBridge(item);
          return;
        }

        clearTimeout(timer.open);
        const anotherIsOpen = this.items.some((other) => other !== item && this.isOpen(other));

        if (anotherIsOpen) {
          // Brief intent check so grazing a neighbour on the way down doesn't steal the menu
          timer.open = setTimeout(() => {
            timer.open = null;
            if (item.matches(':hover')) this.open(item);
          }, MEGA_MENU_SWITCH_DELAY);
        } else {
          this.open(item);
        }
      }

      onPointerLeave(item, event) {
        if (!this.isEnabled(event)) return;
        const timer = this.getTimer(item);

        clearTimeout(timer.open);
        timer.open = null;

        if (!this.isOpen(item)) return;

        clearTimeout(timer.close);
        timer.close = setTimeout(() => {
          timer.close = null;
          if (item.matches(':hover')) return;
          this.close(item);
        }, MEGA_MENU_CLOSE_DELAY);
      }

      onSummaryClick(item, event) {
        if (!this.mediaQuery.matches) return;
        if (event.detail === 0) return;                   // keyboard Enter/Space: keep native toggle
        if (this.lastPointerType === 'touch') return;     // touch: keep native toggle
        if (event.target.closest('a[href]')) return;      // the label link still navigates

        // Mouse click on the summary padding/caret: a hover-opened menu must not
        // toggle shut under the cursor.
        event.preventDefault();
        if (!this.isOpen(item)) this.open(item);
        // global.js flips aria-expanded on every summary click; re-sync afterwards
        setTimeout(() => this.syncAria(item));
      }

      onToggle(item) {
        if (this.isOpen(item)) {
          // Opened by any route (hover, keyboard, other scripts): keep a single mega menu open
          if (this.mediaQuery.matches) {
            this.items.forEach((other) => {
              if (other !== item && this.isOpen(other)) this.close(other);
            });
          }
          this.syncAria(item);
          this.updateBridge(item);
        } else {
          // Closed by any route (StickyHeader.hide, focusout, Escape): drop a stale close timer
          const timer = this.getTimer(item);
          clearTimeout(timer.close);
          timer.close = null;
          this.resetBridge(item);
        }
      }

      onKeyDown(event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        this.items.forEach((item) => {
          if (!this.isOpen(item)) return;
          const hadFocus = item.contains(document.activeElement);
          this.close(item);
          if (hadFocus) this.getParts(item).summary.focus();
        });
      }

      onDocumentClick(event) {
        if (!this.mediaQuery.matches) return;
        const target = event.target;
        this.items.forEach((item) => {
          if (this.isOpen(item) && !(target instanceof Node && item.contains(target))) this.close(item);
        });
      }

      open(item) {
        const parts = this.getParts(item);
        if (!parts) return;

        // Close every other menu and cancel all their pending timers first
        this.items.forEach((other) => {
          if (other !== item) this.close(other);
        });

        this.clearTimers(item);
        if (!parts.details.hasAttribute('open')) parts.details.setAttribute('open', '');
        this.syncAria(item);
        this.updateBridge(item);
        requestAnimationFrame(() => this.updateBridge(item));
      }

      close(item) {
        const parts = this.getParts(item);
        if (!parts) return;
        this.clearTimers(item);
        if (!parts.details.hasAttribute('open')) return;
        parts.details.removeAttribute('open');
        this.syncAria(item);
        this.resetBridge(item);
      }

      closeAll() {
        (this.items || []).forEach((item) => this.close(item));
      }

      syncAria(item) {
        const parts = this.getParts(item);
        if (!parts) return;
        parts.summary.setAttribute('aria-expanded', parts.details.hasAttribute('open') ? 'true' : 'false');
      }

      refreshOpenBridges() {
        (this.items || []).forEach((item) => {
          if (this.isOpen(item)) this.updateBridge(item);
        });
      }

      // Measure the gap between the trigger's bottom edge and the panel's
      // (untransformed) top edge and size the bridge to fill it exactly.
      updateBridge(item) {
        const parts = this.getParts(item);
        if (!parts || !parts.content || !parts.details.hasAttribute('open')) return;
        if (!this.mediaQuery.matches) return this.resetBridge(item);

        const parent = parts.content.offsetParent;
        if (!parent) return;

        const summaryRect = parts.summary.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        // offsetTop ignores transforms, so an opening animation can't skew the measurement
        const contentTop = parentRect.top + parent.clientTop + parts.content.offsetTop;
        const height = Math.max(0, Math.ceil(contentTop - summaryRect.bottom) + 2); // +2px overlap

        // Span the whole nav when items sit on one row; if the nav wraps, only the trigger column
        const navRect = this.nav.getBoundingClientRect();
        const topLevelItems = this.nav.querySelectorAll(':scope > ul > li');
        const navWraps = Array.prototype.some.call(topLevelItems, (li) => li.getBoundingClientRect().top >= summaryRect.bottom - 1);

        const left = navWraps ? 0 : navRect.left - summaryRect.left;
        const width = navWraps ? summaryRect.width : navRect.width;

        parts.details.style.setProperty('--mm-bridge-height', `${height}px`);
        parts.details.style.setProperty('--mm-bridge-left', `${Math.floor(left)}px`);
        parts.details.style.setProperty('--mm-bridge-width', `${Math.ceil(width)}px`);
      }

      resetBridge(item) {
        const parts = this.getParts(item);
        if (!parts) return;
        parts.details.style.removeProperty('--mm-bridge-height');
        parts.details.style.removeProperty('--mm-bridge-left');
        parts.details.style.removeProperty('--mm-bridge-width');
      }
    }

    customElements.define('mega-menu-hover', MegaMenuHover);
  })();

  if (!customElements.get('header-menu')) {
    customElements.define('header-menu', class HeaderMenu extends DetailsDisclosure {});
  }

  document.addEventListener("DOMContentLoaded", function() {
    var menu = document.getElementById("menu");
    var menuSlider = document.getElementById("menuSlider");
    var hamburgerIcon = document.getElementById("hamburgerIcon");

    function toggleMenu() {
        menu.classList.toggle("open");
    }

    hamburgerIcon.addEventListener("click", function() {
        toggleMenu();
    });
});


  } catch(e) { console.error(e); }
})();
})();
